import * as z from "zod";

export const getMintsoftCourierConnection = {
  name: "getMintsoftCourierConnection" as const,
  input: z.null(),
  output: z.object({ connected: z.boolean() }),
};

export const setMintsoftCourierConnection = {
  name: "setMintsoftCourierConnection" as const,
  input: z.object({ connected: z.boolean() }),
  output: z.null(),
};
